import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CODE, RESPONSE_MESSAGE } from 'src/app/modules/utils/Constant';
import SaveTemplateModal from './SaveTemplateModal';
import TemplateListModal from './TemplateListModal';
import { ActionType, ServiceTemplateButtonProps, ServiceTemplateRequest } from './types';
import { getServiceTemplate, saveServiceTemplate } from './services';

const ServiceTemplateButton = ({
	onSelectMau,
	label = 'Đơn thuốc mẫu',
	orderType,
	drop = 'down',
	variant = 'fill',
	tableTitle,
	getRowData,
	columns,
	onSaveValidationFn,
	onSelectValidationFn,
	getSaveParams,
	onSaveSuccess,
	renderAddModalComponent,
	multiSelect,
	disabled,
	searchParams = {},
	allowAdd = true,
}: ServiceTemplateButtonProps) => {
	const [action, setAction] = useState<{
		open: boolean;
		type: ActionType | null;
	}>({
		open: false,
		type: null,
	});

	const onTemplateSelect = async (id: string | string[]) => {
		if (onSelectValidationFn && !onSelectValidationFn()) {
			return;
		}

		try {
			if (Array.isArray(id)) {
				const result = await Promise.all(id.map((id: string) => getServiceTemplate(id)));
				const ordersSet = result.map(({ data }) => data);
				onSelectMau({
					...ordersSet[0],
					lstOrderSetMemebers: ordersSet.map((item) => item.lstOrderSetMemebers).flat()
				});
				onCloseModal();
				toast.success('Sử dụng mẫu thành công');
			} else {
				const { code, data } = await getServiceTemplate(id);
				
				if (CODE.SUCCESS === code) {
					onSelectMau(data);
					onCloseModal();
					toast.success('Sử dụng mẫu thành công');
				}
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	const onCloseModal = () => {
		setAction({
			open: false,
			type: null,
		});
	};

	const onSaveTemplate = () => {
		if (onSaveValidationFn && !onSaveValidationFn()) {
			return;
		}

		setAction({
			open: true,
			type: 'save',
		});
	};

	const onViewTemplate = () => {
		setAction({
			open: true,
			type: 'viewList',
		});
	};

	const onSave = async (thongTinMau: any) => {
		try {
			const request: ServiceTemplateRequest = {
				...thongTinMau,
				...(orderType && { orderType }),
				...getSaveParams(),
			};
			const { code } = await saveServiceTemplate(request);

			if (CODE.SUCCESS === code) {
				toast.success('Lưu mẫu thành công');
				onSaveSuccess && onSaveSuccess();
				onCloseModal();
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	return (
		<Dropdown className="dropdown-btn menu-icon" drop={drop}>
			<Dropdown.Toggle className={`btn-${variant}`} disabled={disabled}>
				{label}
				<i className="bi bi-caret-down-fill spaces pl-4 pr-0 mr-0 pt-2"></i>
			</Dropdown.Toggle>

			<Dropdown.Menu
				className={`${drop === 'up' ? ' dropdown-actions-up' : 'dropdown-actions'}`}
			>
				<Dropdown.Item onClick={onSaveTemplate} hidden={!allowAdd}>
					<div className="ps-5 spaces line-height-30">Lưu vào mẫu mới</div>
				</Dropdown.Item>
				<Dropdown.Item onClick={onViewTemplate}>
					<div className="ps-5 spaces line-height-30">Danh sách các mẫu đã tạo</div>
				</Dropdown.Item>
			</Dropdown.Menu>

			{action.open && action.type === 'save' && (
				<SaveTemplateModal
					open={action.open}
					handleClose={onCloseModal}
					onSave={(value: any) => {
						onSave(value);
					}}
				/>
			)}

			{action.open && action.type === 'viewList' && (
				<TemplateListModal
					open={action.open}
					handleClose={onCloseModal}
					onSelect={(value: any) => {
						onTemplateSelect(value);
					}}
					orderType={orderType}
					tableTitle={tableTitle}
					getRowData={getRowData}
					columns={columns}
					renderAddModal={renderAddModalComponent}
					multiSelect={multiSelect}
					searchParams={searchParams}
				/>
			)}
		</Dropdown>
	);
};

export default ServiceTemplateButton;
